export {unstable_batchedUpdates as batchedUpdates} from 'react-dom'
